import { downMdMql } from '@/mixins/MediaQueryMixin'
import urlManager from '@/urlManager'
import getInitials from '@/utils/getInitials'
import { PALETTE } from '@/constants/common'

const getToolbarGroups = () => {
  const toolbarGroups = [
    { name: 'paragraph', groups: ['list', 'Table', 'blocks'] },
    { name: 'insert', groups: ['Table'] }
  ]
  const isLgScreen = !downMdMql.matches
  if (isLgScreen) {
    toolbarGroups.push({ name: 'clipboard', groups: ['undo'] })
  }
  return toolbarGroups
}
const ENTER_MODE_TAG = {
  pTag: 'p',
  divTag: 'div'
}
const ENTER_MODE = {
  [ENTER_MODE_TAG.pTag]: 1,
  [ENTER_MODE_TAG.divTag]: 3
}

export const activatedEnterModeTag = ENTER_MODE_TAG.pTag

const getBaseConfig = ({ orgId, config, placeholder }) => {
  const baseConfig = {
    // allowedContent: true,
    disallowedContent: 'style',
    extraAllowedContent: 'a[data-user-id](mention)',
    contentsCss: ['/static/styles/ckeditor/overrides-v14.css'],
    defaultLanguage: 'en',
    dialog_noConfirmCancel: true,
    disableNativeSpellChecker: false,
    editorplaceholder: placeholder,
    enterMode: ENTER_MODE[activatedEnterModeTag],
    extraPlugins: 'bullets,editorplaceholder,image2,emoji,quicktable',
    fontSize_defaultLabel: '12',
    format_Large: { element: 'h2', name: 'Large' },
    format_Medium: { element: 'h3', name: 'Medium' },
    format_tags: 'Large;Medium;p',
    language: 'en-us',
    stylesSet: false,
    removeButtons: 'Superscript,Subscript,Unlink,Anchor,Cut,Copy,Paste,Styles',
    removeDialogTabs: 'link:target;link:advanced',
    removePlugins: 'magicline,pastetext,image',
    toolbarGroups: [
      { name: 'styles', groups: ['Format', 'styles', 'basicstyles', 'colors', 'links'] },
      ...getToolbarGroups()
    ],
    toolbarLocation: 'top',
    filebrowserImageUploadUrl: urlManager.fileUpload(orgId, 'Images'),
    filebrowserUploadUrl: urlManager.fileUpload(orgId, 'Files')
  }
  if (!config.disableMentions) {
    baseConfig.extraPlugins += ',mentions'
  }
  return baseConfig
}

const quickTableConfig = {
  qtCellPadding: 4, // Cell padding table
  qtCellSpacing: 4, // Cell spacing table
  qtPreviewSize: '20px', // Preview table cell size
  qtPreviewBackground: '#007ef2' // preview table background (hover)
}

const mentionOutputTemplate = `<a href="#"  class="mention" data-user-id="{id}">@{displayName}</a>`

export const getMentionOutputHTML = (id, displayName) =>
  mentionOutputTemplate.replace(/{id}/, id).replace(/{displayName}/, displayName)

export const getCKEditorConfig = ({
  bodyClass,
  startupFocus,
  height = 300,
  users,
  orgId,
  config = {},
  placeholder
} = {}) => {
  const sortedUsers = users.sort((a, b) => {
    return a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase())
  })
  function dataFeed(opts, callback) {
    let data = sortedUsers
      .filter(function(item) {
        return [...item.firstName.split(' '), ...item.lastName.split(' '), item.email].some(item =>
          item.toLowerCase().startsWith(opts.query.toLowerCase())
        )
      })
      .map(user => ({
        ...user,
        initials: getInitials(user.firstName, user.lastName, user.email),
        color: PALETTE[user.id % PALETTE.length]
      }))
    callback(data)
  }

  const mentionsConfig = [
    {
      feed: dataFeed,
      itemTemplate:
        '<li class="mention-list-item text-medium" data-id="{id}">' +
        '<img class="avatar" data-photo-id="{photoId}" src="/api/files/{photoId}" />' +
        '<span class="initials text-mini" data-color="{color}" style="background-color: {color};">{initials}</span>' +
        '<span class="fullname">{displayName}</span>' +
        '</li>',
      outputTemplate: mentionOutputTemplate + '<span>&nbsp;</span>',
      minChars: 0
    }
  ]
  const editorConfig = {
    ...getBaseConfig({ orgId, config, placeholder }),
    ...quickTableConfig,
    bodyClass,
    startupFocus,
    height
  }
  if (!config.disableMentions) {
    editorConfig.mentions = mentionsConfig
    editorConfig.users = users
  }
  return editorConfig
}
